module.exports = __webpack_public_path__ + "gin_andr_qr.9001ac3.png";